import { CiBellOn, CiLocationArrow1, CiChat1 } from "react-icons/ci";


export const GetNotificationIcon = (type) => {
    if (type === 'orderDirectMessage' || type === 'orderTenderDirectMessage') {
        return <CiChat1 className={"h-6 w-6 items-center mt-1 lg:-ml-2 mr-4"}/>
    }  else if (type === 'progressUpdateTender' || type === 'progressUpdate' || type === 'progressUpdateStageBack' || type === 'progressUpdateStuck') {
        return <CiLocationArrow1 className={"h-6 w-6 items-center  mt-1 lg:-ml-2  mr-4"}/>
    } else {
        return <CiBellOn className={"h-6 w-6 items-center  mt-1 lg:-ml-2  mr-4"}/>
    } 
};